module.exports = __webpack_public_path__ + "img/b4.b31c9e77.jpg";